import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as BaseCarIcon } from 'assets/images/autos/icon-car.svg';
import { ReactComponent as Bed } from 'assets/images/bed.svg';
import Button from 'components/Buttons/Button';
import Field from 'components/Field';

export const Container = styled.div`
  height: 100%;
  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${ColorPalette.HEX.Lotion};
    padding: 32px 16px;
  }
`;

export const Title = styled.h3`
  font-weight: 600;
  line-height: 1.33;
  letter-spacing: -0.24px;
  color: ${ColorPalette.HEX.PineTree};
  margin-bottom: 22px;
`;

export const ItineraryCard = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px 16px 30px 0;
  width: 100%;
  border-top: solid 1px ${ColorPalette.HEX.BrightGray};
  border-bottom: solid 1px ${ColorPalette.HEX.BrightGray};
  margin: 24px 0 16px 0;
`;

export const ItineraryText = styled.span`
  font-size: 12px;
  line-height: 1.5;
  margin-left: 12px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.PineTree};

  & > b {
    font-size: 16px;
    font-weight: 600;
    margin-right: 8px;
  }
`;

export const AirplaneIcon = styled.img`
  height: 20px;
  width: 20px;
`;

export const CarIcon = styled(BaseCarIcon)`
  height: 16px;
  width: 16px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const HotelIcon = styled(Bed)`
  height: 20px;
  width: 20px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
  }
`;

export const ColombiaTax = styled.span`
  font-size: 10px;
  line-height: 1.6;
  color: ${ColorPalette.HEX.Manatee};
`;

export const StyledField = styled(Field)`
  margin-top: 8px;
`;

export const StyledButton = styled(Button)`
  height: 56px;
`;

export const NoShowText = styled.p`
  font-size: 12px;
  height: auto;
  @media ${({ theme }) => theme.device.mobile} {
    height: 220px;
  }
`;

export const NoShowTextImportant = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: red;
`;

export const Tag = styled.div`
  margin-top: 16px;
  padding-right: 5px;
`;
